
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[campaign]/rule",
      function () {
        return require("private-next-pages/[campaign]/rule.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[campaign]/rule"])
      });
    }
  